<template>
    <div class="login-setting panel">
      <div class="title">登录方式<a-button class="title-btn" type="primary" @click="loginSettingEdit">设置</a-button></div>
      <div class="info">登录方式：{{loginTypeText}}</div>
      <div class="info" v-if='model.loginType1==="1"'>校验信息：{{checkFields}}</div>
      <login-setting-modal ref="LoginSettingModal" @ok="loginSettingEditOk" :fieldList="fieldList"></login-setting-modal>
    </div>
</template>

<script>
  import { getAction , postAction} from '@/api/manage'
  import LoginSettingModal from './modal/LoginSettingModal'
  export default {
    name: 'LoginSetting',
    components: { LoginSettingModal },
    props:{
      projectId:{
        type:String,
        default:'',
      },
      baseModel:{
        type:Object,
        default:()=>{
          return {}
        },
      },
    },
    data(){
      return {
        model:{},
        setFieldList:[],
        fieldList:[],
      }
    },
    watch:{
      baseModel(){
        this.loadData()
      },
    },
    computed:{
      checkFields(){
        let result = ''
        if(this.setFieldList){
          this.setFieldList.forEach(item=>{
            result+=`${item.fieldName}、`
          })
        }
        if(result){
          result = result.substring(0,result.length-1)
        }
        return result
      },
        loginTypeText(){
          let result = ''
          if(this.model.loginType1==='1'){
            result+='手动登录，'
          }
          if(this.model.loginType2==='2'){
            result+='微信自动登录，'
          }
          if(result){
            result = result.substring(0,result.length-1)
          }
          return result
        }
    },
    mounted(){

      this.loadData()
    },
    methods:{
      loadData(){
        this.model = Object.assign({},this.baseModel)
        if(this.model.projectId){
          getAction('/project/projectPatientField/listAll2',{projectId:this.model.projectId}).then(res=>{
            if(res.success){
              this.fieldList = res.result
            }
          })
          getAction('/project/projectPatientFillLoginField/list',{fillId:this.model.id}).then(res=>{
            if(res.success){
              this.setFieldList = res.result
            }
          })
        }
      },
      loginSettingEdit(){
        this.$refs['LoginSettingModal'].edit(this.model,this.setFieldList)
      },
      loginSettingEditOk(form,setFieldList) {
        form.fieldList = setFieldList
        postAction('/project/projectPatientFill/editLogin',form).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            // this.setFieldList = setFieldList
            this.$emit('ok')
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>